import Vue from "vue";
import api from "../ApiBase";

export default {
    /**
     * Update employee after mapping action
     * @param {object} sourceEmployee 
     * @param {object} targetEmployee 
     */
    async updateEmployeeMapping(sourceEmployee, targetEmployee) {
        try {
            Vue.$log.debug("updateMapEmployeeMapping: ", sourceEmployee ," to ", targetEmployee);
            await api.post('UpdateMapEmployee?id=' + sourceEmployee.master_employee_id + '&mitarbeiter_mapping_key=' 
                + targetEmployee.mitarbeiter_mapping_key + '&name=' + sourceEmployee.master_name+ '&id_copy=' 
                + sourceEmployee.master_employee_id);
            Vue.$log.debug("Successfully updated map employee mapping");
        } catch (error) {
            Vue.$log.error("Fehler beim Updaten des Mitarbeiters", error);
            return null;
        }
    },

    /**
     * Update employee after unmappig action
     * @param {object} sourceEmployee 
     */
    async updateEmployeeUnmapping(sourceEmployee) {
        try {
            Vue.$log.debug("updateUnmapEmployeeMapping: ", sourceEmployee);
            await api.post('UpdateUnmapEmployee?mitarbeiter_mapping_key=' + sourceEmployee.mitarbeiter_mapping_key);
            Vue.$log.debug("Successfully updated unmap employee mapping");
        } catch (error) {
            Vue.$log.error("Fehler beim Updaten des Mitarbeiters", error);
            return null;
        }
    },

    /**
     * Get missing employees by echtIds
     * @param {Array} echtIds - Array of employee IDs to check for missing mappings
     * @returns {Promise<Array>} - Returns a promise that resolves to an array of missing employees
     */
    async getMissingPunchTimeEmployees(echtIds) {
        try {
            Vue.$log.debug("GetMissingMappedEmployees");
            const response = await api.get('GetMissingMappedEmployees?echt_ids=' + echtIds);
            Vue.$log.debug("Successfully fetched missing employees");
            return response.data;
        } catch (error) {
            Vue.$log.error("Fehler beim Abrufen der fehlenden Mitarbeiter", error);
            return null;
        }
    },

    async getShiftTimeEmployees(echtIds) {
        try {
            Vue.$log.debug("GetShiftTimeEmployees");
            const response = await api.get('GetShiftTime?echt_ids=' + echtIds);
            Vue.$log.debug("Successfully fetched missing employees");
            return response.data;
        } catch (error) {
            Vue.$log.error("Fehler beim Abrufen der fehlenden Mitarbeiter", error);
            return null;
        }
    },

    async getAbsentEmployees(echtIds) {
        try {
            Vue.$log.debug("GetAbsentEmployees");
            const response = await api.get('GetAbsentEmployees?echt_ids=' + echtIds);
            Vue.$log.debug("Successfully fetched absent employees");
            return response.data;
        } catch (error) {
            Vue.$log.error("Fehler beim Abrufen der fehlenden Mitarbeiter", error);
            return null;
        }
    }
}